module.exports = __webpack_public_path__ + "fonts/Roboto-300-latin30.665db5e.woff2";